import ComponentElement from 'components/component-element';
import Modal from 'developer_components/newModal';
import TouristLeadsForm from 'components/tourist-leads/form';
import SuccessDialog from 'components/tourist-leads/dialogs/success';
import WidgetMenu from 'components/tourist-leads/widget-menu';
// import WidgetBanner from 'components/tourist-leads/widget-banner';
import {
    getWidgetContacts,
    isBannerCollapsed,
    isHotelPage,
    openMaxLink,
    openPhoneCall,
    reachContactGoal,
    reachGoal,
    resolveMaxLinkPromise,
} from 'components/tourist-leads/widget-actions';
import {isMobile} from 'methods/utils';

function Widget($element, options = {}) {
    if (typeof window.touristLeadsWidget !== 'undefined') {
        return window.touristLeadsWidget;
    }

    $element.innerHTML = `
        <svg width="48" height="48" fill="none" version="1.1" viewBox="0 0 26.087 26.087" xmlns="http://www.w3.org/2000/svg">
         <g stroke-width=".54348">
          <rect transform="scale(-1)" x="-26.087" y="-26.087" width="26.087" height="26.087" rx="13.043" fill="#316bff"/>
          <path d="m10.435 12.391c-0.12897 0-0.25506 0.03826-0.36234 0.10989-0.10723 0.07168-0.19082 0.17353-0.24016 0.29272-0.049402 0.11913-0.062283 0.25027-0.037121 0.37679 0.025163 0.12652 0.087283 0.24272 0.17848 0.33391 0.091197 0.0912 0.20739 0.15332 0.33391 0.17848 0.12652 0.02516 0.25766 0.01229 0.3768-0.03707 0.11918-0.0494 0.22103-0.13299 0.29272-0.24022 0.07164-0.10728 0.10989-0.23337 0.10989-0.36234 0-0.17299-0.0687-0.33886-0.19103-0.46114-0.12228-0.12234-0.28815-0.19103-0.46114-0.19103zm2.6087 0c-0.12897 0-0.25505 0.03826-0.36234 0.10989-0.10723 0.07168-0.19082 0.17353-0.24016 0.29272-0.04941 0.11913-0.06229 0.25027-0.03711 0.37679 0.02516 0.12652 0.08728 0.24272 0.17848 0.33391 0.09119 0.0912 0.20739 0.15332 0.33391 0.17848 0.12652 0.02516 0.25766 0.01229 0.37679-0.03707 0.11918-0.0494 0.22103-0.13299 0.29272-0.24022 0.07163-0.10728 0.10989-0.23337 0.10989-0.36234 0-0.17299-0.0687-0.33886-0.19103-0.46114-0.12228-0.12234-0.28815-0.19103-0.46114-0.19103zm2.6087 0c-0.12897 0-0.25505 0.03826-0.36234 0.10989-0.10723 0.07168-0.19082 0.17353-0.24016 0.29272-0.04941 0.11913-0.06229 0.25027-0.03711 0.37679 0.02516 0.12652 0.08729 0.24272 0.17848 0.33391 0.09119 0.0912 0.20739 0.15332 0.33391 0.17848 0.12652 0.02516 0.25766 0.01229 0.37679-0.03707 0.11918-0.0494 0.22103-0.13299 0.29272-0.24022 0.07163-0.10728 0.10989-0.23337 0.10989-0.36234 0-0.17299-0.0687-0.33886-0.19103-0.46114-0.12228-0.12233-0.28816-0.19103-0.46114-0.19103zm-2.6087-5.8696c-0.85647 0-1.7045 0.1687-2.4958 0.49641-0.79125 0.32777-1.5102 0.80815-2.1158 1.4138-1.223 1.2231-1.9102 2.8819-1.9102 4.6116-0.00571 1.506 0.51576 2.9664 1.4739 4.1283l-1.3043 1.3043c-0.09049 0.09168-0.15179 0.20815-0.17614 0.33467-0.024402 0.12652-0.010762 0.25745 0.039186 0.3762 0.054184 0.11734 0.14201 0.21592 0.25228 0.28332 0.11033 0.06733 0.23815 0.10038 0.36728 0.09494h5.8696c1.7297 0 3.3885-0.68712 4.6116-1.9102 1.223-1.2231 1.9102-2.8819 1.9102-4.6116s-0.68712-3.3885-1.9102-4.6116c-1.223-1.223-2.8819-1.9102-4.6116-1.9102zm0 11.739h-4.2978l0.60652-0.60652c0.061631-0.06038 0.11065-0.13245 0.14424-0.2119 0.033587-0.07951 0.051087-0.16484 0.051413-0.25114-0.0024457-0.17201-0.072772-0.33609-0.19565-0.45652-0.85397-0.85304-1.3858-1.9758-1.5048-3.1768-0.11897-1.2011 0.18212-2.4064 0.85212-3.4104 0.66995-1.004 1.6673-1.7447 2.8221-2.0958 1.1548-0.35114 2.3956-0.29098 3.5111 0.17016 1.1154 0.46114 2.0365 1.2948 2.6062 2.3589 0.56973 1.0641 0.75294 2.2928 0.51832 3.4768-0.23462 1.184-0.8725 2.2501-1.8049 3.0165-0.9325 0.76641-2.1018 1.1859-3.3089 1.1868z" fill="#ffffff"/>
          <rect x="19.565" width="6.5217" height="6.5217" rx="3.2609" fill="#00ea65"/>
         </g>
        </svg>
        `;

    $element.classList.add('Tourist-leads-widget--init');

    ComponentElement.call(this, $element, options);

    window.touristLeadsWidget = this;

    this.widgetContacts = getWidgetContacts();
    this.maxLinkPromise = resolveMaxLinkPromise(this.widgetContacts);
    // меню из 3 пунктов только на мобилке, на десктопе кнопка сразу открывает форму подбора
    this.isMobileView = isMobile();
    this.shouldShowBanner = this.isMobileView && !isHotelPage() && !isBannerCollapsed();

    if (this.isMobileView) {
        this.menu = new WidgetMenu({
            onAction: (action) => this.handleAction(action, 'widget'),
        });

        this.menu.on('open', () => {
            this.$element.classList.add('is-opened');
        });

        this.menu.on('close', () => {
            this.$element.classList.remove('is-opened');
        });
    }

    const $modal = Modal.createFromHTML(`
        <div class="Tourist-leads-widget-modal js-tourist-leads-widget-modal">
            <div class="Tourist-leads__close Modal-native__close js-modalClose"></div>
        </div>
    `, { id: 'Tourist-leads-widget-modal', className: 'Tourist-leads-widget-modal' });

    this.modal = new Modal($modal);

    if (!this.isMobileView) {
        this.modal.on('open', () => reachGoal('widget_open'));
    }

    this.form = this.makeForm({
        on: {
            submit: () => {
                this.modal.close().then(() => new SuccessDialog({'short': true}));
            },
        },
        source: 'widget',
    });

    this.modal.$element.querySelector('.js-tourist-leads-widget-modal').insertAdjacentElement('beforeend', this.form.$element);

    // if (this.shouldShowBanner) {
        // this.banner = new WidgetBanner({
        //     onAction: (action) => this.handleAction(action, 'banner'),
        //     onCollapse: () => this.showButton(),
        // });

        // this.hideButton();
    // }

    this.$element.addEventListener('click', () => {
        if (!this.menu) {
            this.handleAction('podbor', 'widget');
            return;
        }

        if (this.menu.isOpened()) {
            this.menu.close();
            return;
        }

        this.menu.open();
    });
}

Widget.prototype = Object.create(ComponentElement.prototype);
Object.defineProperty(Widget.prototype, 'constructor', {
    value: Widget,
    enumerable: false,
    writable: true,
});

Widget.prototype.hideButton = function() {
    this.$element.classList.add('is-collapsed');
};

Widget.prototype.showButton = function() {
    this.$element.classList.remove('is-collapsed');
};

Widget.prototype.handleAction = function(action, placement) {
    reachContactGoal(action, placement);

    if (action === 'podbor') {
        this.modal.open();
        return;
    }

    if (action === 'max') {
        openMaxLink(this.maxLinkPromise);
        return;
    }

    if (action === 'call') {
        openPhoneCall(this.widgetContacts?.phone_tel);
    }
};

Widget.prototype.makeForm = function(options) {
    return new TouristLeadsForm(options)
        .section({
            cls: 'description',
            description: `
                <p class="title">Подберём жильё для отдыха с учетом ваших пожеланий и бюджета.</p>
                <p class="subtitle">Оставьте контакты - свяжемся с вами и предложим подходящие варианты.</p>
            `,
        })
        .section({
            destination: {
                value:  this.$element?.dataset?.city,
                hidden: this.$element?.dataset?.city,
            },
        })
        .section({
            pickers: {
                datePicker: {
                    datepickerPosition: 'right',
                    required: true,
                },
                peoplePicker: false,
            },
        })
        .section({
            name: true,
        })
        .section({
            phone: true,
        })
        .section({
            email: {
                required: false,
                message: {
                    show: true,
                    text: 'Свяжемся с вами по телефону, а на почту отправим подтверждение заявки',
                },
            },
            input: {
                id: 'widget_subscription',
                name: 'subs_place',
                value: 'widget_subscription',
            },
        })
        .section({
            comment: {
                label: 'Пожелания',
                rows: 3,
                placeholder: 'Укажите количество гостей, бюджет или другие пожелания'
            },
        })
        .section({
            agreement: true,
        })
        .section({
            mailing: true,
        })
        .section({
            submitter: {
                disabled: true,
            },
        });
};

export default Widget;
